export default __webpack_public_path__ + "static/media/augDom2023.a3bac51d.png";